import React from 'react'
import { capitalize } from 'lodash'
import RecordingGroupCategory from '@App/enum/recording-group-category'
import { PaginationBody, PaginationInfo } from '@Entities/pagination'
import { INumTitles } from '@App/helpers/pagination/get-num-titles'
import PaginationResultsBlock from '@Components/Navigations/PaginationResultsBlock'
import RecordingGroupGrid from '@Scenes/RightsholderScene/MatchHistory/v2/MatchHistoryRecordingGroups/RecordingGroupGrid'
import PaginationAndLimit from '@Components/Navigations/PaginationAndLimit'

interface RecordingGroupTabProps {
    status: RecordingGroupCategory
    totalCount: number
    numTitles: INumTitles | undefined
    paginationData: PaginationInfo | undefined
    onPageChange: (p: PaginationBody) => void
    onLimitChange: (newLimit: number) => void
    resultsLimit: number
}

const RecordingGroupTab: React.FC<RecordingGroupTabProps> = ({
    status,
    totalCount,
    numTitles,
    paginationData,
    onPageChange,
    onLimitChange,
    resultsLimit,
}) => (
    <div className="recording-group-section">
        <div className="recording-group-table-header">
            <h5 className="recording-group-type">
                {capitalize(status)} Recording Groups ({totalCount})
            </h5>
            <span className={`recording-group-type-status-circle ${status.toLowerCase()}`} />
        </div>
        <PaginationResultsBlock totalResults={totalCount} workNumTitles={numTitles} />
        <br />
        <RecordingGroupGrid foundStatus={status} />
        <PaginationAndLimit
            paginationInfo={paginationData}
            onPageChange={onPageChange}
            onLimitChange={onLimitChange}
            count={totalCount}
            limit={resultsLimit}
        />
    </div>
)

export default RecordingGroupTab
